import * as React from 'react';
import {connect} from 'react-redux';

const RadioUnchecked = (props: any) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    fill={props?.globalStyles?.primaryColor}
    stroke={props?.globalStyles?.primaryColor}
    stroke-width="0.00024000000000000003"
    {...props}>
    <g data-name="Layer 2">
      <path
        d="M12 22a10 10 0 1 1 10-10 10 10 0 0 1-10 10zm0-18a8 8 0 1 0 8 8 8 8 0 0 0-8-8z"
        data-name="radio-button-off"
      />
    </g>
  </svg>
);

const mapStateToProps = ({globalStyles}: any) => ({
  globalStyles: globalStyles.value,
});

export default connect(mapStateToProps)(RadioUnchecked);
